const en = {
  menu: {
    about: { title: "About Us" },
    products: {
      title: "Products",
      tea: "Tea",
      coffee: "Coffee",
      agricultural: "Agricultural",
      energyDrink: "Energy Drink",
      juice: "Guava Juice",
      oil: "Cooking Oil",
    },
    promotion: { title: "Promotions" },
    news: {
      title: "News",
      newsTea: "Tea news",
      newsCoffee: "Coffee news",
      newsAgri: "Agricultural news",
    },
    noidia: { title: "Domestic" },
    xuatkhau: { title: "Export" },
    recruitment: { title: "Jobs" },
    muahang: { title: "Purchase" },
    contact: { title: "Contact" },
    search: { title: "Search" },
    profile: { title: "Profile" },
    language: { title: "Language" },
  },
  footer: {
    addressLabel: "Address",
    customerPolicy: "CUSTOMER POLICY",
    contactInfo: "Contact Info",
    factory: "FACTORY ADDRESS",
    followUs: "FOLLOW US",
    contactWith: "CONNECT WITH VIET THIEN",
    payments: "Payment methods",
    cod: "COD",
    bankTransfer: "Bank transfer",
    wallet: "Electronic wallet",
    info1:
      "Business Certificate Number: 0305693542 – Issued on Febuary 22, 2008",
    info2: "By the Department of Planning and Investment of HCM City.",
    menu: "Menu",
    about: "About Us",
    operation: "Industries",
    news: "News & Events",
    contact: "Contact",
    recruitment: "Recruitment",
    policy: "Terms of Use",
    workingtime: "Working Hours",
    time1: "Monday - Friday: 08:00 - 17:00",
    time2: "Saturday: 08:00 - 12:00",
    connect: "Connect With Us",
    companyName: "NGOC PHUONG DONG INVESTMENT TRADE JOINT STOCK COMPANY",
  },
  contact: {
    content:
      "If you have any concern or wish to cooperate, please leave your information, we will assist you as soon as possible.",
    taxCodeLabel: "Tax code",
    email: "Email",
    address: "Office",
    form: {
      title: "Contact us",
      fullName: "Name",
      email: "Email",
      phone: "Phone number",
      address: "Address",
      content: "Comments",
      button: "Submit",
      loading: "Sending...",
    },
    placeholder: {
      fullName: "Your name",
      email: "Your email address",
      phone: "Your phone number",
      content: "Enter a comment here...",
      address: "Your address",
    },
    toast: {
      success: "Your information has been sent successfully.",
      error: "Failed to send information. Please try again later.",
    },
    map: {
      title: "List of Viet Thien factories",
    },
  },
  news_flow: {
    latest_update: "Latest Update",
    title: "News & Events",
    view_all: "View all",
    read_more: "Read more",
    back_to_list: "Back to news list",
    editorial_board: "Tay Bac Duc Hoa Dong IC Management",
    share: "Share",
    related_news: "Related News",
    search_placeholder: "Search news...",
    no_results: "No news found matching your criteria.",
    categories: {
      all: "All",
      company: "Industrial Cluster News",
      market: "Market News",
      product: "Product",
      event: "Events",
    },
    blog_title: "News & Events",
    blog_subtitle1: "Latest Updates from",
    blog_subtitle2: "Tay Bac Duc Hoa Dong IC",
    blog_desc:
      "Stay updated with the latest news about Tay Bac Duc Hoa Dong Industrial Cluster, project progress, investment opportunities and key events.",
    promo_title: "Register for Investment Consultation",
    promo_desc:
      "Contact us now for detailed information on land availability and special offers for investors.",
    promo_btn: "Contact Us",
  },
  landingModel: {
    profit: "Profit",
    investment: "Investment",
    ownership: "ownership",
    or: "or",
    authorized: "partner authorized",
    swipe: "Swipe horizontally to view model",
    investor: "INVESTOR",
    returnProfit: "Dividends / Principal return",
    deposit: "Deposit (taybacduchoadong)",
    factory: "Factory",
    others: "Other industries",
    agricultureExport: "Agricultural Export (Viet Thien)",
    startupCo: "Startup Co",
    realEstate: "Real Estate",
  },
  landingProblem: {
    downloadBtn: "Download App Now",
  },
  landingHero: {
    downloadBtn: "Download Now",
  },
  landingSolution: {
    downloadBtn: "Download App Now",
  },
  landingAppExp: {},
  landingProjects: {
    downloadBtn: "Download App Now",
  },
  landingCTA: {
    downloadBtn: "Download Now",
  },
  pdfViewer: {
    titleScript: "Look Up",
    titleNormal: "LOCATION & PLANNING INFO",
    downloadTooltip: "Download PDF",
    fullscreenTooltip: "Fullscreen",
    loadingText: "Loading document...",
    fileNames: {
      "1": "Factory Plots Layout",
      "2": "Northwest Industrial Cluster Map",
      "3": "Project Profile (e-Brochure)"
    }
  },
  industrialLanding: {
    phone: "098999999999",
    consult: "CONSULTATION",
    news: {
      titleScript: "NEWS",
      titleAmp: " & ",
      titleMain: "EVENTS",
      detailsTitle: "NEWS DETAILS"
    },
    contact: {
      btnSubmit: "Submit Registration",
      btnSending: "Sending...",
      errorSubmit: "Failed to submit information",
      errorSystem: "An error occurred, please try again",
      successTitle: "Success!",
      successDesc: "Thank you for your interest. We will contact you as soon as possible.",
      btnClose: "Close"
    }
  }
};

export default en;
